<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('cms_add') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                 <form ref="form" :data-url='`/our-team/update/${teamdata.id}`' class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('name') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="teamdata.name"
                                   :required="true"
                                   :placeholder="$t('name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('designation') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="teamdata.designation"
                                   :placeholder="$t('designation_name')"/>
                    </div>
                    <div class="form-group row">
                        <label for="inputs_editor" class="col-sm-2 h-fit-content">
                            {{ $t('about') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="text-editor"
                                       id="text-editor-id"
                                       :label="$t('message_placeholder')" v-model="teamdata.about"/>
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                      <label for="number_input" class="col-sm-2 mb-sm-0">
                          {{ $t('order_on') }}
                      </label>
                      <app-input id="number_input"
                                 class="col-sm-8"
                                 type="number"
                                 v-model="teamdata.order_on"
                                 :placeholder="$t('number_type_input')"/>
                  </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('facebook_id') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="teamdata.facebook_id"
                                   :required="false"
                                   :placeholder="$t('facebook_id_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('linkedin_id') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="teamdata.linkedin_id"
                                   :required="false"
                                   :placeholder="$t('linkedin_id_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('twitter_id') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="teamdata.twitter_id"
                                   :required="false"
                                   :placeholder="$t('twitter_id_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_keyword') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="teamdata.meta_keyword"
                                   :required="false"
                                   :placeholder="$t('meta_key_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="teamdata.meta_title"
                                   :required="false"
                                   :placeholder="$t('meta_title_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_description') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="textarea"
                                   v-model="teamdata.meta_description"
                                   :required="false"
                                   :placeholder="$t('meta_description_name')"/>
                    </div>                    
                    
                    <div class="form-group row">
                        <label for="teamThumbImage" class="col-lg-3 col-xl-3 col-form-label h-fit-content">
                            {{ $t('upload_thumb_image') }}<br>
                            <small class="text-muted font-italic">
                                {{ $t('recommended_team_thumb_size') }}
                            </small>
                        </label>
                        <div class="col-sm-4">
                            <app-input id="teamThumbImage"
                                       type="custom-file-upload"
                                       :generate-file-url="false"
                                       v-model="reqData.thumb_image"
                                       :label="$t('upload_your_thumb_file')"/>
                        </div>
                        <div class="custom-image-upload-wrapper" v-if="teamdata.thumb_image">
                            <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="teamdata.thumb_image"
                                :alt-text="$t('not_found')"/>
                        </div>
                    </div> 

                    <div class="form-group row">
                        <label for="teamFeaturedImage" class="col-lg-3 col-xl-3 col-form-label h-fit-content">
                            {{ $t('upload_image') }}<br>
                            <small class="text-muted font-italic">
                                {{ $t('recommended_team_featured_size') }}
                            </small>
                        </label>
                        <div class="col-sm-4">
                            <app-input id="teamFeaturedImage"
                                       type="custom-file-upload"
                                       :generate-file-url="false"
                                       v-model="reqData.featured_image"
                                       :label="$t('upload_your_file')"/>
                        </div>
                        <div class="custom-image-upload-wrapper" v-if="teamdata.featured_image">
                            <app-avatar :title="$t('avatars')" class="image-area d-flex" :img="teamdata.featured_image"
                                :alt-text="$t('not_found')"/>
                        </div>
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="teamdata.status"
                                       :required="true"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('profile') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="checkboxLists"
                                       v-model="teamdata.featured"
                                       :required="false"/>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {axiosPost} from "../../../../Helpers/AxiosHelper";  
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    import * as actions from '../../../../Config/ApiUrl';
    export default {
        name: "UpdateCMS",
        mixins: [FormMixin],
        props: ['teamdata'],
        data(){
          return {           
            preloader: false,
            reqData: {},                
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ],
                checkboxLists: [
                    {id: '1', value: "Yes"},
                    {id: '0', value: "No"}
                ]
          }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.teamdata)) {
                  if (value != null) formData.append(key, value);                  
                }
                if (this.reqData.featured_image) {
                    formData.append("featured_image", this.reqData.featured_image);
                }
                if (this.reqData.thumb_image) {
                    formData.append("thumb_image", this.reqData.thumb_image);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location.reload();
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }
    }
</script>